/* src/app/feature-modules/tutor-list/import-tutor/import-tutor.component.css */
.toast-container {
  background-image: linear-gradient(purple, red) !important;
  border-radius: 22px !important;
  box-shadow: -5px 8px 16px 0px rgba(0, 0, 0, 0.3) !important;
  margin-bottom: 2px !important;
}
.toast-container .toast-top-right toast-container {
  margin: 2px !important;
  box-shadow: none !important;
  border-radius: 20px !important;
  background-color: #fff !important;
}
/*# sourceMappingURL=import-tutor.component.css.map */
